exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-file-upload {\n  border: 1px solid #ccc;\n  display: inline-block;\n  padding: 6px 12px;\n  cursor: pointer;\n  margin-top: 5px;\n  border-radius: 5px; }\n\n.custom-file-upload:hover {\n  background-color: #e1f2f3; }\n\n.popUpStyle {\n  display: flex;\n  justify-content: space-around;\n  align-items: center; }\n\n.buttonCss {\n  background-color: #15b2bf;\n  border: none;\n  color: white;\n  padding: 5px 15px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  border-radius: 8px; }\n\n.yearStyle {\n  padding: 0px 15px; }\n\n.button-header-container {\n  display: flex;\n  align-items: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/component/observation-table/style.scss
// module id = 1427
// module chunks = 0